// Appointment Service
import api from './api';

const appointmentService = {
  bookAppointment: (appointmentData) => api.post('/appointments', appointmentData),
  getAppointments: (filters) => api.get('/appointments', { params: filters }),
  getAppointmentById: (id) => api.get(`/appointments/${id}`),
  updateAppointmentStatus: (id, status) => api.put(`/appointments/${id}/status`, { status }),
  rescheduleAppointment: (id, data) => api.put(`/appointments/${id}/reschedule`, data),
  cancelAppointment: (id, reason) => api.put(`/appointments/${id}/cancel`, { reason }),
  getAvailableSlots: (barberId, serviceId, date) =>
    api.get('/appointments/slots/available', {
      params: { barberId, serviceId, date },
    }),
  getAnalytics: (period) => api.get('/appointments/analytics', { params: { period } }),
  generateInvoice: (appointmentId) => api.get(`/appointments/${appointmentId}/invoice`),
};

export default appointmentService;
